import { ISliderValueDisp } from "../../interfaces/ISliderValueDisp";

import DisplayObject = createjs.DisplayObject;
import Container = createjs.Container;

export class BasicSliderValueContainer implements ISliderValueDisp {
    private slider: Container;
    private sliderBar: Container;
    private filledBar: Container;

    constructor(container: Container) {
        this.slider = (<Container>container.getChildByName("slider"));
        this.sliderBar = (<Container>container.getChildByName("slideBar"));
        this.filledBar = (<Container>this.sliderBar.getChildByName("fillBar"));
    }

    public getSlider(): DisplayObject {
        return this.slider;
    }

    public getSliderBar(): DisplayObject {
        return this.sliderBar;
    }

    public getFilledBar(): DisplayObject {
        return this.filledBar;
    }
}
